import styled, { css } from 'styled-components';

export const Iframe = styled.iframe`
  ${({ isFastCheckoutCaller }) => css`
    max-width: ${isFastCheckoutCaller ? 'none' : '400px'};
    border: none;
  `};
`;
